@if (readOnly) {
  <div id="crm-additional-team-member-form">
    <div class="crm-field-label">{{ 'CRM.CUSTOM_INPUT.TEAM_MEMBERS' | translate }}</div>
    <div class="crm-field-value">
      @if (teamMembers(); as teamMembers) {
        @if (teamMembers !== NO_VALUE_FOR_TEAM_MEMBER) {
          <div>
            <div class="tags">
              <glxy-badge [glxyTooltip]="teamMemberNames().join(', ')">{{ teamMemberNames()[0] }}</glxy-badge>
              @if (teamMemberNames().length === 2) {
                <glxy-badge [glxyTooltip]="teamMemberNames().join(', ')">
                  {{ teamMemberNames()[1] }}
                </glxy-badge>
              }
              @if (teamMemberNames().length > 2) {
                <glxy-badge [glxyTooltip]="teamMemberNames().join(', ')">
                  +{{ teamMemberNames().length - 1 }}
                </glxy-badge>
              }
            </div>
          </div>
        }
      } @else {
        <div class="stencil-shimmer"></div>
      }
    </div>
  </div>
} @else {
  <glxy-form-field>
    <glxy-label>{{ 'CRM.CUSTOM_INPUT.TEAM_MEMBERS' | translate }}</glxy-label>
    <mat-chip-grid [disabled]="loadingValues()" #teamMemberGrid aria-label="Team member selection">
      @if (loadingValues()) {
        <mat-spinner [diameter]="24"></mat-spinner>
      } @else {
        @for (teamMember of selectedTeamMembers(); track teamMember) {
          <mat-chip-row
            (removed)="remove(teamMember.userId); saveField()"
            >
            {{ teamMember.displayName }}
            <button matChipRemove [attr.aria-label]="'remove ' + teamMember.displayName">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
      }
      <input
        matInput
        #teamMemberInput
        [placeholder]="'Select...'"
        [formControl]="searchControl"
        [matChipInputFor]="teamMemberGrid"
        [matAutocomplete]="auto"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false"
        (matChipInputTokenEnd)="add($event)"
        (blur)="saveField()"
        data-testid="filter-additional-team-member-input"
        />
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (option of filteredOptions(); track option) {
        <mat-option
          [value]="option?.userId"
          (mousedown)="$event.preventDefault()"
          >
          {{ option?.displayName }}
        </mat-option>
      }
    </mat-autocomplete>
    @if (formGroup.errors?.additionalTeamMemberIsOwner) {
      <glxy-error>
        {{ 'CRM.FORMS.OWNER_IN_ADDITIONAL_TEAM_MEMBERS' | translate }}
      </glxy-error>
    }
  </glxy-form-field>
}
